import { Component, computed, inject, input } from '@angular/core';
import { LinkField } from '@core/jss-proxy';
import { CrntIcon } from '@essent/current-web-angular';
import { IconIcon } from '@essent/current-web';
import { GenericLinkDirective } from '@core/jss-utils';
import { ShowInLiveDirective } from '@core/experience-editor-components';
import { ContentSectionService } from '@core/ui/content-section';
import { NgClass } from '@angular/common';

@Component({
  selector: 'wl-content-top-tasks-button',
  standalone: true,
  imports: [CrntIcon, GenericLinkDirective, NgClass, ShowInLiveDirective],
  templateUrl: './content-top-tasks-button.component.html',
  styleUrls: [
    './content-top-tasks-button.component.ed.scss',
    './content-top-tasks-button.component.essent.scss',
  ],
})
export class ContentTopTasksButtonComponent {
  readonly theme = inject(ContentSectionService).theme;
  readonly link = input<LinkField>();
  readonly icon = input<{
    fields: { value: { value: IconIcon } };
  }>();

  readonly linkText = computed(() => this.link()?.value?.text);
  readonly iconValue = computed(() => this.icon()?.fields?.value?.value);
}
